<template>
  <div>
    <h1>
      {{ header }}
    </h1>

    <p>
      {{ subtext }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    header: {
      type: String,
    },
    subtext: {
      type: String,
    },
  },
};
</script>

<style scoped>
h1 {
  font-weight: bolder !important;
}
</style>
